import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { faDownload } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { SirmetJakamoApi } from "src/api/generated/tenants/sirmet/sirmetJakamoApi.ts";
import { ReceivedCustomerOrdersActionBarComponentsProps } from "src/tenantCustomizations/TenantCustomizations.ts";

export const SirmetReceivedCustomerOrdersActionBarComponents = ({
	refreshData,
}: ReceivedCustomerOrdersActionBarComponentsProps) => {
	return (
		<AsyncButton
			label={i18n.t("fetch_jakamo_orders")}
			icon={faDownload}
			variant={"outlined"}
			onClick={async () => {
				await SirmetJakamoApi.fetchJakamoOrders();
				await refreshData();
			}}
		/>
	);
};

